import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { NeverShowRouteResolver } from '../shared/navigation/never-show-route-resolver';
import { PageNotFoundComponent } from './page-not-found.component';
import { PermissionLevel } from '../shared/permission/permission';
import { RouteType } from '../shared/navigation/route-type.enum';
import { VersionGuard } from '../shared/guards/version-guard';

export const pageNotFoundRoutes: Array<DynamicRoute> = [
  {
    path: '404',
    component: PageNotFoundComponent,
    canActivate: [VersionGuard],
    data: {
      show: NeverShowRouteResolver,
      title: 'Page Not Found',
      icon: 'icon-dashboard.svg',
      permissionLevel: PermissionLevel.MANAGER,
      type: [RouteType.NORMAL]
    }
  }
];
